import script from "./musicTime.vue?vue&type=script&setup=true&lang=js"
export * from "./musicTime.vue?vue&type=script&setup=true&lang=js"

import "./musicTime.vue?vue&type=style&index=0&id=d3b94f32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3b94f32"]])

export default __exports__